<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $tc("gender", 2) }}</div>
      <div>
        <router-link
          v-if="$can('update', 'Gender')"
          class="btn-blue"
          @click.native="goToRoute('/user-management/edit-gender')"
          to
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="genders"
          >{{ $tc("gender", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div
            v-for="(item, index) in Gender"
            :key="index"
            class="col-md-12 py-2"
          >
            <span v-if="login_user_role_id === 1">
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'created_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_at'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue | dateparse }}</div>
              </div>
              <div
                class="row border-bottom"
                v-if="item.fieldname == 'updated_by'"
              >
                <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
                <div class="col-lg-9">{{ item.fieldvalue }}</div>
              </div>
            </span>
            <div
              class="row border-bottom"
              v-if="
                item.fieldname !== 'gender_id' &&
                item.fieldname !== 'created_at' &&
                item.fieldname !== 'created_by' &&
                item.fieldname !== 'updated_by' &&
                item.fieldname !== 'updated_at' &&
                item.fieldname !== 'dept_is_active'
              "
            >
              <div class="col-lg-3">{{ $tc(item.fieldkey, 1) }}</div>
              <div class="col-lg-9">{{ item.fieldvalue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Gender from "@/helper/formJSONMaster/Gender";

export default {
  data() {
    return {
      login_user_role_id: null,
      tableId: null,
      Gender: [
        ...Gender.ms_gender,
        {
          fieldname: "created_by",
          fieldkey: "createdby",
          fieldvalue: "123456",
          type: "text",
        },
        {
          fieldname: "created_at",
          fieldkey: "createdat",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_by",
          fieldkey: "modifiedby",
          fieldvalue: true,
          type: "text",
        },
        {
          fieldname: "updated_at",
          fieldkey: "modifiedat",
          fieldvalue: true,
          type: "text",
        },
      ],

      Methods: Gender.Methods,
      submitted: false,
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.tableId = id;
      this.getViewList(id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    goToRoute: function (path) {
      this.$router.push({
        path: path,
        query: {
          id: this.tableId,
        },
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getViewList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Gender.map((x, index) => {
              if (x.fieldname === "created_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Gender");
              } else if (x.fieldname === "updated_by") {
                this.getViewUsersDetails(obj[x.fieldname], index, "Gender");
              } else if (x.fieldname === "gender_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? "Yes" : "No";
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    getViewUsersDetails(user_id, index, key) {
      this[key][index].fieldvalue = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][index].fieldvalue = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/GenderComponents/viewGender.vue